export default __webpack_public_path__ + "static/media/02.c316c207.png";